import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TooltipDirective } from '@presentation/directives';
import { ActionButtonComponent } from '../action-button';
import { LinkComponent } from '../link';

@Component({
  selector: 'cm-case-number',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LinkComponent, ActionButtonComponent, TooltipDirective],
  templateUrl: './case-number.component.html',
  styleUrl: './case-number.component.less',
})
export class CaseNumberComponent {
  public readonly caseId = input.required<string>();
  public readonly caseNumber = input.required<string>();
  public readonly routePrefix = input<string>('/cases');
  public readonly navigable = input<boolean>(true);
  public readonly unreadMessageCount = input<number>(0);
  public readonly hasMessages = input<boolean>(false);
  public readonly isMarkedAsRead = input<boolean>(false);
  public readonly showComments = input<boolean>(true);
  /** Override the link aut-id. Defaults to `case-link-<caseId>`. */
  public readonly autId = input<string>();
  /** Override the link accessible label. Defaults to `View case <caseNumber>`. */
  public readonly ariaLabel = input<string>();

  public readonly routerLinkName = computed(() => `${this.routePrefix()}/${this.caseId()}`);

  public readonly linkAutId = computed(() => this.autId() ?? `case-link-${this.caseId()}`);

  public readonly linkAriaLabel = computed(
    () => this.ariaLabel() ?? `View case ${this.caseNumber()}`,
  );

  public readonly commentsClicked = output<Event>();

  public readonly hasUnread = computed(
    () => this.unreadMessageCount() > 0 && !this.isMarkedAsRead(),
  );

  /** Show the comments button when the case has any messages, or has unread ones. */
  public readonly showCommentsButton = computed(
    () => this.showComments() && (this.hasMessages() || this.hasUnread()),
  );

  public readonly commentsAriaLabel = computed(() =>
    this.hasUnread()
      ? `View ${this.unreadMessageCount()} unread comments`
      : 'View comments',
  );

  public onCommentsClick(event: Event): void {
    event.stopPropagation();
    this.commentsClicked.emit(event);
  }
}
